var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_1290_6159)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5539 28.8889H10.8853C10.1144 28.8889 9.73361 28.8889 9.50143 28.7355C9.25066 28.5676 9.09742 28.2894 9.07884 27.9824C9.06489 27.6996 9.25531 27.3541 9.6361 26.6635L18.6943 10.1731C19.0798 9.47285 19.2748 9.12272 19.5209 8.99323C19.7856 8.85415 20.1014 8.85415 20.3661 8.99323C20.6122 9.12272 20.8073 9.47285 21.1927 10.1731L23.0549 13.5304L23.0644 13.5476C23.4807 14.2988 23.6918 14.6798 23.784 15.0796C23.8861 15.5161 23.8861 15.9765 23.784 16.413C23.6911 16.8158 23.4821 17.1995 23.0595 17.9621L18.3015 26.6491L18.2891 26.6713C17.8701 27.4287 17.6577 27.8126 17.3634 28.1022C17.043 28.4189 16.6575 28.649 16.2349 28.7787C15.8495 28.8889 15.4176 28.8889 14.5539 28.8889ZM23.8183 28.8889H29.075C29.8505 28.8889 30.2407 28.8889 30.473 28.7309C30.7237 28.5629 30.8815 28.2798 30.8956 27.973C30.909 27.6993 30.7227 27.3673 30.3577 26.7168C30.3451 26.6946 30.3326 26.6721 30.3197 26.6492L27.6866 21.9969L27.6566 21.9445C27.2866 21.2983 27.0999 20.9719 26.86 20.8458C26.5954 20.7067 26.2841 20.7067 26.0195 20.8458C25.778 20.9753 25.583 21.3158 25.1975 22.0017L22.5738 26.654L22.5648 26.67C22.1807 27.3548 21.9888 27.697 22.0026 27.9777C22.0212 28.2847 22.1744 28.5676 22.4252 28.7355C22.6527 28.8889 23.0428 28.8889 23.8183 28.8889Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1290_6159",
    x1: 40,
    y1: 40,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D91D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7576"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/avax.68ea6ee3d5db7d15d3c624e569a9d72e.svg";
export { ForwardRef as ReactComponent };